import Button from "@components/ui/button";
import Icon from "@components/ui/icon";
import { StockSkeleton } from "./stock-skeleton";

interface IProps {
  onReload: () => void;
}

export const StockError = ({ onReload }: IProps) => {
  return (
    <div className="tw-relative tw-flex tw-flex-col tw-items-center tw-overflow-hidden tw-pt-6 tw-text-center">
      <StockSkeleton noAnim />
      <div className="tw-absolute tw-left-1/2 tw-top-1/2 tw-w-full -tw-translate-x-1/2 -tw-translate-y-1/2">
        <Icon
          icon="ri-error-warning-fill"
          className="tw-text-[24px]/none tw-text-red-base"
        />
        <div className="tw-text-md tw-mb-4 tw-mt-1 tw-font-medium">
          Failed to load, please try again
        </div>

        <Button variant="secondary" size="sm" onClick={onReload}>
          <Icon icon="ri-refresh-line" className="tw-mr-1.5" />
          Reload
        </Button>
      </div>
    </div>
  );
};
